export default function WelcomeAnimation() {
  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <style>{`
        @keyframes float-1 { 0%,100%{transform:translateY(0px)} 50%{transform:translateY(-14px)} }
        @keyframes float-2 { 0%,100%{transform:translateY(-6px)} 50%{transform:translateY(9px)} }
        @keyframes float-3 { 0%,100%{transform:translateY(5px)} 50%{transform:translateY(-11px)} }
        @keyframes float-4 { 0%,100%{transform:translateY(-9px)} 50%{transform:translateY(6px)} }
        @keyframes float-5 { 0%,100%{transform:translateY(0px)} 50%{transform:translateY(-16px)} }
        @keyframes float-6 { 0%,100%{transform:translateY(7px)} 50%{transform:translateY(-7px)} }
        @keyframes float-7 { 0%,100%{transform:translateY(-5px)} 50%{transform:translateY(11px)} }
        .wa-n1{animation:float-1 5.2s ease-in-out infinite}
        .wa-n2{animation:float-2 4.4s ease-in-out infinite}
        .wa-n3{animation:float-3 6.1s ease-in-out infinite}
        .wa-n4{animation:float-4 4.8s ease-in-out infinite}
        .wa-n5{animation:float-5 5.7s ease-in-out infinite}
        .wa-n6{animation:float-6 4.1s ease-in-out infinite}
        .wa-n7{animation:float-7 6.5s ease-in-out infinite}
        @keyframes data-flow {
          0%{stroke-dashoffset:120}
          100%{stroke-dashoffset:-120}
        }
        .wa-pulse{stroke-dasharray:8 56;animation:data-flow 3s linear infinite}
        .wa-pulse-slow{stroke-dasharray:6 70;animation:data-flow 4.5s linear infinite}
        .wa-pulse-fast{stroke-dasharray:10 44;animation:data-flow 2.2s linear infinite}
      `}</style>
      <svg
        viewBox="0 0 480 400"
        className="w-full h-full"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden="true"
      >
        <defs>
          <radialGradient id="glow-a" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#1752B7" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#1752B7" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="glow-e" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#1752B7" stopOpacity="0.22" />
            <stop offset="100%" stopColor="#1752B7" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="glow-b" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#1752B7" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#1752B7" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Static wire lines */}
        <g stroke="#1752B7" strokeOpacity="0.10" strokeWidth="1.5" fill="none">
          {/* A(85,75) — B(250,50) */}
          <line x1="85" y1="75" x2="250" y2="50" />
          {/* B(250,50) — C(420,105) */}
          <line x1="250" y1="50" x2="420" y2="105" />
          {/* A(85,75) — D(50,215) */}
          <line x1="85" y1="75" x2="50" y2="215" />
          {/* B(250,50) — E(310,205) */}
          <line x1="250" y1="50" x2="310" y2="205" />
          {/* C(420,105) — E(310,205) */}
          <line x1="420" y1="105" x2="310" y2="205" />
          {/* D(50,215) — F(160,340) */}
          <line x1="50" y1="215" x2="160" y2="340" />
          {/* E(310,205) — F(160,340) */}
          <line x1="310" y1="205" x2="160" y2="340" />
          {/* E(310,205) — G(415,355) */}
          <line x1="310" y1="205" x2="415" y2="355" />
        </g>

        {/* Animated pulse lines */}
        <g fill="none" strokeLinecap="round">
          <line className="wa-pulse" x1="85" y1="75" x2="250" y2="50"
            stroke="#1752B7" strokeWidth="2" strokeOpacity="0.55" style={{animationDelay:"0s"}} />
          <line className="wa-pulse-slow" x1="250" y1="50" x2="420" y2="105"
            stroke="#1752B7" strokeWidth="1.5" strokeOpacity="0.45" style={{animationDelay:"1.1s"}} />
          <line className="wa-pulse-fast" x1="85" y1="75" x2="50" y2="215"
            stroke="#1752B7" strokeWidth="1.5" strokeOpacity="0.40" style={{animationDelay:"0.4s"}} />
          <line className="wa-pulse" x1="250" y1="50" x2="310" y2="205"
            stroke="#1752B7" strokeWidth="2" strokeOpacity="0.55" style={{animationDelay:"0.8s"}} />
          <line className="wa-pulse-slow" x1="420" y1="105" x2="310" y2="205"
            stroke="#1752B7" strokeWidth="1.5" strokeOpacity="0.40" style={{animationDelay:"1.6s"}} />
          <line className="wa-pulse-fast" x1="50" y1="215" x2="160" y2="340"
            stroke="#1752B7" strokeWidth="1.5" strokeOpacity="0.40" style={{animationDelay:"0.2s"}} />
          <line className="wa-pulse" x1="310" y1="205" x2="160" y2="340"
            stroke="#1752B7" strokeWidth="2" strokeOpacity="0.50" style={{animationDelay:"1.3s"}} />
          <line className="wa-pulse-slow" x1="310" y1="205" x2="415" y2="355"
            stroke="#1752B7" strokeWidth="1.5" strokeOpacity="0.45" style={{animationDelay:"0.6s"}} />
        </g>

        {/* Node A — top-left, large glow */}
        <g className="wa-n1">
          <circle cx="85" cy="75" r="34" fill="url(#glow-a)" />
          <circle cx="85" cy="75" r="13" fill="#1752B7" fillOpacity="0.10" />
          <circle cx="85" cy="75" r="8" fill="#1752B7" fillOpacity="0.55" />
          <circle cx="85" cy="75" r="4.5" fill="#1752B7" />
        </g>

        {/* Node B — top-center */}
        <g className="wa-n2">
          <circle cx="250" cy="50" r="22" fill="url(#glow-b)" />
          <circle cx="250" cy="50" r="9" fill="#1752B7" fillOpacity="0.12" />
          <circle cx="250" cy="50" r="5.5" fill="#1752B7" fillOpacity="0.50" />
          <circle cx="250" cy="50" r="3" fill="#1752B7" />
        </g>

        {/* Node C — top-right */}
        <g className="wa-n3">
          <circle cx="420" cy="105" r="18" fill="url(#glow-b)" />
          <circle cx="420" cy="105" r="7" fill="#1752B7" fillOpacity="0.12" />
          <circle cx="420" cy="105" r="4" fill="#1752B7" fillOpacity="0.45" />
          <circle cx="420" cy="105" r="2.5" fill="#1752B7" />
        </g>

        {/* Node D — left */}
        <g className="wa-n4">
          <circle cx="50" cy="215" r="18" fill="url(#glow-b)" />
          <circle cx="50" cy="215" r="7" fill="#1752B7" fillOpacity="0.12" />
          <circle cx="50" cy="215" r="4" fill="#1752B7" fillOpacity="0.45" />
          <circle cx="50" cy="215" r="2.5" fill="#1752B7" />
        </g>

        {/* Node E — center-right, largest hub */}
        <g className="wa-n5">
          <circle cx="310" cy="205" r="48" fill="url(#glow-e)" />
          <circle cx="310" cy="205" r="18" fill="#1752B7" fillOpacity="0.10" />
          <circle cx="310" cy="205" r="11" fill="#1752B7" fillOpacity="0.50" />
          <circle cx="310" cy="205" r="6" fill="#1752B7" />
        </g>

        {/* Node F — bottom-left */}
        <g className="wa-n6">
          <circle cx="160" cy="340" r="24" fill="url(#glow-b)" />
          <circle cx="160" cy="340" r="10" fill="#1752B7" fillOpacity="0.12" />
          <circle cx="160" cy="340" r="6" fill="#1752B7" fillOpacity="0.50" />
          <circle cx="160" cy="340" r="3.5" fill="#1752B7" />
        </g>

        {/* Node G — bottom-right */}
        <g className="wa-n7">
          <circle cx="415" cy="355" r="20" fill="url(#glow-b)" />
          <circle cx="415" cy="355" r="8" fill="#1752B7" fillOpacity="0.12" />
          <circle cx="415" cy="355" r="5" fill="#1752B7" fillOpacity="0.45" />
          <circle cx="415" cy="355" r="3" fill="#1752B7" />
        </g>
      </svg>
    </div>
  );
}
